export default "__VITE_ASSET__BROsqmxL__"